import type { PetSpecies } from '../api/pet-verification';
import type { PrettyValue } from '../types/pretty-value';

type PrettyPetSpecies = { [key in PetSpecies]: PrettyValue };

export const PRETTY_PET_SPECIES: PrettyPetSpecies = {
  Dog: {
    text: 'Dog',
  },
  Cat: {
    text: 'Cat',
  },
  Other: {
    text: 'Other',
  },
};
